<template>
  <div class="login-box">

    <div class="login-head">
      <img src="../../assets/image/avator/logo-white.png" class="logo">
      <h3 class="head-text">红袜子商户后台</h3>
    </div>
    <div class="login_container">
      <div class="flex-between login_box">
        <div class="flex-body flex-column-items-center">
          <h1>红袜子账号登录</h1>
          <!-- 头像底部字体 -->
          <!-- 登录表单 -->
          <el-form label-width="0px" class="login_form" ref="loginForm" :model="loginForm" :rules="loginRules">
            <!-- 用户名 -->
            <el-form-item class="login_form_input" prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入用户名"
                suffix-icon="rs-iconfont rs-icon-keyboardalt"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item class="login_form_input mt-50" prop="password" :error="error"> 
              <el-input
                v-model="loginForm.password"
                type="password"
                suffix-icon="rs-iconfont rs-icon-32mimaxiugai"
                show-password
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <!-- 按钮区域 --> 
            <el-form-item class="btns">
              <!-- <button class="btn-primary-white ml-15 btn2" @click="applyToJoin">加入我们</button> -->
              <!-- 忘记密码 -->
              <el-popover
                placement="top-start"
                width="200"
                trigger="click"
                content="为了保证账号的安全，请联系你的专属客服经理">
                <el-button type="text" slot="reference" class="color-blue fs-12 forget-psw">忘记密码</el-button>
              </el-popover>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" round class="mt-30 w-100 btn1" :disabled="loading" :loading="loading" @click="handleLogin">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loading: false,
      error: null,
      loginRules: {
        username: [
          { required: true, message:'请输入用户名',trigger: 'blur' },
          { min:3,max:60,message:'长度在3到7个字符',trigger:'blur'}
        ],
        password: [
          { required: true, message:'请输入密码',trigger: 'blur' },
          { min:6,max:20,message:'长度在6到20个字符',trigger:'blur'}
        ]
      },
      loginForm: {
        username: '',
        password: ''
      },
    }
  },
  methods: {
    handleLogin (e) {
      this.error = null;
      e.preventDefault();
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('Login', this.loginForm).then(() => {
            this.loading = false
            this.$router.push('/homepage')
            return false
          }).catch((err) => {
            this.error = this.$t(err.data.error || null);
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    applyToJoin(){
      this.$router.push("/join");
    }
  },
  i18n: {
    messages: {
      zh: {
        'Username or password does not matches user.': '用户名或密码错误。'
      },
    }
  }
}
</script>

<style lang="scss" scoped>
.login-head {
  background-color: $primary;
  padding: 40px 0 56px 0;
  text-align: center;
  .logo {
    width: 108px;
  }
  .head-text {
    margin: 20px auto;
    width: 506px;
    height: 76px;
    line-height: 76px;
    border-radius: 8px;
    border: 2px solid #FFFFFF;
    color: #fff;
    font-size: 30px;
    font-weight: 500;
  }
}
  .login_container {
    .login_box {
      margin-top: 105px;
      width: 100%;
      overflow: hidden;
      flex-wrap: nowrap;
      h1{
        font-size: 40px;
        font-weight: 600;
        color: #333;
      }
      .login_form {
        margin-top: 30px;
        .login_form_input{
          height: 45px;
          border-radius: 6px;
        }
        .forget-psw{
          margin-top: -5px;
          float: right;
        }
        .btns {
          .btn1{
            border-radius: 18px;
          }
        }
      }
    }
    ::v-deep .el-input__inner{
      width: 506px;
      height: 45px;
      background-color: #fff !important;
      border: 1px solid #979797;
      border-radius: 6px;
      padding-left: 48px
    }
    ::v-deep .el-input__suffix {
      right: 25px;
      .rs-iconfont {
        font-size: 22px;
      }
    }
    ::v-deep .el-form-item__error {
      margin-left: 50px;
      margin-top: 5px;
    }
  }
</style>
